import React from 'react';
import { format } from 'date-fns';
import { FaMinus } from 'react-icons/fa';
import formatContact from '~/util/formatContact';
import { Container, Main, TdTable, Td, Ticket, CompanyInfo } from './styles';

// Componente para renderizar código QR
const Barcode = ({ value }) => {
  // Gerar URL para QR code usando API QRServer.com
  const getQRCodeUrl = text => {
    const encodedText = encodeURIComponent(text);
    // API gratuita do QRServer
    return `https://api.qrserver.com/v1/create-qr-code/?data=${encodedText}&size=150x150&margin=10&format=svg`;
  };

  if (!value) return <FaMinus />;

  // Renderizar imagem QR Code com fallback para FaMinus em caso de erro
  return (
    <img
      src={getQRCodeUrl(value)}
      alt="QR Code"
      style={{
        width: '80px',
        height: '80px',
      }}
      onError={e => {
        // eslint-disable-next-line no-console
        console.error('QR Code loading error');
        e.target.parentNode.replaceChild(
          document.createTextNode('Erro QR Code'),
          e.target
        );
      }}
    />
  );
};

const DeliveryProtocol = ({ protocols, company }) => {
  const phoneCompany = company.phone
    ? company.phone > 9999999999
      ? formatContact(3, company.phone)
      : formatContact(2, company.phone)
    : '';

  return (
    <Container>
      <Main>
        {protocols && company && (
          <>
            {protocols.map((protocol, index) => (
              <div key={protocol.id}>
                {index > 0 && <hr />}
                <Ticket border="1">
                  <thead>
                    <tr>
                      <td rowSpan="2" colSpan="1">
                        <div className="logo">
                          <img
                            src={
                              company.logo
                                ? company.logo_url
                                : 'https://myhappen.blob.core.windows.net/files-companies/28978_config_company_logo.png'
                            }
                            alt="icone-logo"
                            width="110"
                            height="110"
                          />
                        </div>
                      </td>
                      <Cell
                        rowSpan="1"
                        colSpan="1"
                        className="protocol"
                        label="Protocolo"
                        value={protocol.client.name}
                        body={
                          <>
                            <span>
                              {`${protocol.client.addresses[0].street}, ${protocol.client.addresses[0].number} - ${protocol.client.addresses[0].neighborhood} - ${protocol.client.addresses[0].city}`}
                            </span>
                          </>
                        }
                      />
                      <Cell
                        rowSpan="1"
                        colSpan="1"
                        className="number"
                        value={protocol.cod}
                        label="Número"
                      />
                      <Cell
                        rowSpan="2"
                        colSpan="1"
                        className="qrcode"
                        value={<Barcode value={protocol.cod || 'TEST123'} />}
                      />
                    </tr>
                    <tr>
                      <Cell
                        rowSpan="1"
                        colSpan="1"
                        className="protocol"
                        value={protocol.receiver || ''}
                        label="Assinatura"
                      />
                      <Cell
                        rowSpan="1"
                        colSpan="1"
                        className="number"
                        value={protocol.delivered_date}
                        label="Data de recebimento"
                      />
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan="4">
                        <TdTable>
                          <table>
                            <thead>
                              <tr>
                                <th className="cod">Cód.</th>
                                <th className="document">Documento</th>
                                <th className="comp">Comp.</th>
                                <th className="deadline">Venc.</th>
                                <th className="price">Valor</th>
                                <th className="obs">Obs.</th>
                              </tr>
                            </thead>
                            <tbody>
                              {/* Limita o número de documentos visíveis para garantir que caiba em uma página */}
                              {protocol.documents.slice(0, 10).map(item => (
                                <tr key={item.id}>
                                  <td className="cod">
                                    {item.document.barcode}
                                  </td>
                                  <td className="document">
                                    {item.document.description?.length > 25
                                      ? `${item.document.description.substring(
                                          0,
                                          25
                                        )}...`
                                      : item.document.description}
                                  </td>
                                  <td className="comp">{item.competence}</td>
                                  <td className="deadline">
                                    {item.deadline_formatted || <FaMinus />}
                                  </td>
                                  <td className="price">
                                    {item.price || <FaMinus />}
                                  </td>
                                  <td className="obs">
                                    {item.obs?.length > 20
                                      ? `${item.obs.substring(0, 20)}...`
                                      : item.obs || 'Sem observações'}
                                  </td>
                                </tr>
                              ))}
                              {protocol.documents.length > 10 && (
                                <tr>
                                  <td
                                    colSpan="6"
                                    style={{
                                      textAlign: 'center',
                                      fontStyle: 'italic',
                                    }}
                                  >
                                    {'...e mais '}
                                    {protocol.documents.length - 10}
                                    {' documento(s)'}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </TdTable>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <Cell
                        rowSpan="1"
                        colSpan="1"
                        className="date"
                        value={format(new Date(), 'dd/MM/yyyy')}
                        label="Data de impressão"
                      />
                      <Cell
                        rowSpan="1"
                        colSpan="3"
                        className="user"
                        value={protocol.created_by || ''}
                        label="Usuário"
                      />
                    </tr>
                  </tfoot>
                </Ticket>
                <CompanyInfo>
                  <strong>{company.name}</strong>
                  <span>{phoneCompany}</span>
                  <span>{company.email}</span>
                </CompanyInfo>
              </div>
            ))}
          </>
        )}
      </Main>
    </Container>
  );
};

export default DeliveryProtocol;

const Cell = ({ label, value, className, rowSpan, colSpan, body }) => {
  return (
    <Td rowSpan={rowSpan} colSpan={colSpan}>
      <div className={className}>
        {label && <span>{label}</span>}
        <strong>{value}</strong>
        <strong>{body}</strong>
      </div>
    </Td>
  );
};
